import React from 'react'
import './Faq.scss';
import Accordion from 'react-bootstrap/Accordion'

function Faq() {
    return (
        <div id="faq">
            <div className='sectionHeader'>
                <h2 className='sectionTitle'>FAQ</h2>
                <p className='sectionSubtitle'>Frequently Asked Questions</p>
            </div>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>How do I recieve my proxies?</Accordion.Header>
                        <Accordion.Body>
                        You will receive your proxies instantly via our dashboard.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>How do I recieve my proxies?</Accordion.Header>
                        <Accordion.Body>
                        You will receive your proxies instantly via our dashboard.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>How do I recieve my proxies?</Accordion.Header>
                        <Accordion.Body>
                        You will receive your proxies instantly via our dashboard.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>How do I recieve my proxies?</Accordion.Header>
                        <Accordion.Body>
                        You will receive your proxies instantly via our dashboard.
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
        </div>
    )
}

export default Faq
